import gql from 'graphql-tag';

export const RESOURCES_QUERY = gql`
    query Resource($ticker: String!) {
        mutualFund(ticker: $ticker) {
            cusip
            trpCode
        }
    }
`;

export const ETF_RESOURCES_QUERY = gql`
    query ETFResource($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            cusip
            trpCode
            ticker
        }
    }
`;
